import { render, staticRenderFns } from "./worker-image-upload.vue?vue&type=template&id=25264740&scoped=true&"
import script from "./worker-image-upload.vue?vue&type=script&lang=js&"
export * from "./worker-image-upload.vue?vue&type=script&lang=js&"
import style0 from "./worker-image-upload.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25264740",
  null
  
)

export default component.exports